// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2GioR","selects":"Documents_selects__38WsJ"};